<template>
  <form class="flex h-full flex-col" @submit="onSubmit">
    <div class="flex grow flex-col items-center space-y-2">
      <div class="font-bold">Set your supervisor PIN</div>
      <div class="mb-2 text-sm">
        You'll use this PIN to access this device
      </div>
      <PinInput
        :model-value="formValues.pin"
        @update:model-value="setFieldValue('pin', $event)"
      />
    </div>
    <ActionButtonPrimary type="submit">
      Set PIN
    </ActionButtonPrimary>
  </form>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { setSupervisorPin } from "@/services/onboarding/setSupervisorPin"

type Emits = {
  (event: "stage-complete"): void
}

const emit = defineEmits<Emits>()

const { startLoading, stopLoading } =
  usePageBlockingLoading()

const pinFormSchema = z.object({
  pin: z
    .string()
    .length(4, { message: "Pin must be 4 characters long" })
    .regex(/\d+/, {
      message: "Pin must only contain numeric characters",
    }),
})

const {
  handleSubmit,
  values: formValues,
  setFieldValue,
} = useForm({
  validationSchema: toTypedSchema(pinFormSchema),
  initialValues: {
    pin: "",
  },
})

const onSubmit = handleSubmit(async (validatedValues) => {
  startLoading()

  try {
    await setSupervisorPin(validatedValues)
    emit("stage-complete")
  } catch {
    toast.error("Failed to set supervisor PIN")
  } finally {
    stopLoading()
  }
})
</script>
